import { 
  createRouter, 
  createWebHistory, 
  RouteRecordRaw,
  RouteLocationNormalized,
  RouteLocationNormalizedLoaded,
  RouterScrollBehavior
} from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import(/* webpackChunkName: "Services" */ '../views/Services.vue')
  },
  {
    path: '/services/:slug',
    name: 'ServiceDetail',
    component: () => import(/* webpackChunkName: "ServicePage" */ '../views/ServicePage.vue'),
    props: true
  },
  {
    path: '/careers',
    name: 'careers',
    component: () => import(/* webpackChunkName: "Careers" */ '../views/Careers.vue')
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: () => import(/* webpackChunkName: "AboutUs" */ '../views/AboutUs.vue')
  },
  {
    path: '/contact',
    name: 'contact-us',
    component: () => import(/* webpackChunkName: "ContactUs" */ '../views/ContactUs.vue'),
    props: true
  },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: () => import(/* webpackChunkName: "TermsOfService" */ '../views/TermsOfService.vue'),
    props: true
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import(/* webpackChunkName: "PrivacyPolicy" */ '../views/PrivacyPolicy.vue'),
    props: true
  },
  {
    path: '/case-studies',
    name: 'caseStudies',
    component: () => import(/* webpackChunkName: "CaseStudies" */ '../views/CaseStudies.vue')
  },
  {
    path: '/case-studies/:path',
    name: 'CaseStudyPage',
    component: () => import(/* webpackChunkName: "CaseStudyPage" */ '../views/CaseStudyPage.vue'),
    props: true
  },
  {
    path: '/specialist-divisions/:slug',
    name: 'SpecialistDivisionDetail',
    component: () => import(/* webpackChunkName: "SpecialistDivisionPage" */ '../views/SpecialistDivision.vue'),
    props: true
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    component: () => import(/* webpackChunkName: "PageNotFound" */ '../views/PageNotFoundView.vue')
  }
]

const scrollBehavior: RouterScrollBehavior = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
  savedPosition: { left: number; top: number } | null
) => {
  if (savedPosition) return savedPosition
  if (to.hash) return { el: to.hash }
  if (from.path === to.path) return {}

  if (from && Object.keys(to.query).length) {
    if (to.fullPath.split('?')[0] === from.fullPath.split('?')[0]) return
  }

  return { top: 0, behavior: 'smooth' }
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior
})

export default router